import { useEffect } from 'react';
import { ReactNode } from 'react';
import { useLocation } from "react-router-dom";

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Header, MARKETPLACE_GWT, MARKETPLACE_DEV_CONTEXT, logOut } from '@marketplace/common';

import classes from './common-layout.module.scss';

type TDashboardLayoutProps = {
  children: ReactNode;
  leftSection?: string | ReactNode;
  rightSection?: ReactNode;
  leftHeaderSection?: ReactNode;
  rightHeaderSection?: ReactNode;
  logo?: ReactNode;
  leftNavigationBar?: ReactNode;
  banner?: ReactNode;
};

export const CommonLayout = ({
  children,
  leftSection,
  rightSection,
  leftHeaderSection,
  rightHeaderSection,
  logo,
  leftNavigationBar,
  banner,
}: TDashboardLayoutProps) => {
  const isAuthenticated = localStorage.getItem(MARKETPLACE_GWT);
  const isAuthorizedDeveloper = localStorage.getItem(MARKETPLACE_DEV_CONTEXT);
  const params = useLocation();

  useEffect(()=>{
    if(!isAuthenticated && !isAuthorizedDeveloper && params.pathname.split('/')[1] === 'developer') {
      logOut()
    }
  },[])

  return (
    <>
      <Header
        leftSection={leftHeaderSection}
        rightSection={rightHeaderSection}
        logo={logo}
        banner={banner}
      />
      <div
        className={
          leftNavigationBar
            ? classes.container_without_padding
            : classes.container
        }
      >
        <div className={classes.page_content}>
          {leftNavigationBar}
          <div className={classes.right_section_content}>
            {(leftSection || rightSection) && (
              <div className={classes.top_content}>
                {leftSection}
                {rightSection}
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
    </>
  )};
